import { render, staticRenderFns } from "./CarrelloDialog.vue?vue&type=template&id=0c97b261&"
import script from "./CarrelloDialog.vue?vue&type=script&lang=ts&"
export * from "./CarrelloDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CarrelloDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports